<template>
  <div class="body">
    <!--<img src="https://wpimg.wallstcn.com/0e03b7da-db9e-4819-ba10-9016ddfdaed3" alt="">-->
    <!--<accessory :btn="'上传附件'" @callback='getMd5' states/>-->
  </div>
</template>
<script>

import Accessory from "@/components/common/accessory";

export default {
  components: {Accessory},
  data() {
    return {}
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.$nextTick(() => {
        this.$store.dispatch('auth/loginByToken');
      });

    }
  },
}
</script>

<style lang="less" scoped>
.body {
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
